<div>{{ "legacy" | translate }}</div>
